import { MfaType, QueryParams, QueryResult } from "common";
import { hasValueFn } from "@partner/shared/Tools";

export enum UserDbRole {
  ADMIN = "administrator",
  USER = "user",
  DEVELOPER = "developer",
}

export interface UserData {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  role: UserDbRole;
  brokerId: number;
  mobilePhone: string;
  active: boolean;
  status: UserStatus;
  mfaType: MfaType;
  isAuthenticatorAppRegistered: boolean;
}

export enum UserStatus {
  None = "none",
  Invited = "invited",
  Active = "active",
  Disabled = "disabled"
}

export const UserStatusLabel = new Map<UserStatus, string>([
  [UserStatus.None, "None"],
  [UserStatus.Invited, "Invited"],
  [UserStatus.Active, "Active"],
  [UserStatus.Disabled, "Disabled"],
]);


export type EditUserData = Omit<UserData, "id" | "status" | "isAuthenticatorAppRegistered">;

export interface UsersQueryResult extends QueryResult<UserData> {}

interface UserQueryParamOptions extends QueryParams {
  roles?: string;
}

export class UserQueryParams extends QueryParams {
  roles?: string;

  constructor(params?: UserQueryParamOptions) {
    super(params);
    params = params ?? {};
    this.active = params.active ?? true;
    this.roles = params.roles ?? undefined;
  }
}

interface UserFilterOptions {
  active?: boolean | string;
  roles?: string;
}

export class UserFilters {
  active: boolean | undefined;
  roles: string | undefined;

  constructor(filters?: UserFilterOptions) {
    filters = filters ?? {};
    this.roles = filters.roles ?? undefined;
    this.active =
      hasValueFn(filters.active, v => v.toString() === "true") ?? true;
  }
}

export enum UserOverflowActions {
  DISABLE = "Disable",
  DELETE = "Delete",
}
